'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const NormalTextIcon = createIcon({
    displayName: 'NormalTextIcon',
    viewBox: '0 0 20 20',
    fill: 'none',
    path: (
        <path
            d="M3.333 5.833c0-.776 0-1.164.127-1.47.17-.41.494-.734.902-.903.307-.127.695-.127 1.471-.127h8.334c.776 0 1.165 0 1.471.127.408.17.733.494.902.902.127.307.127.695.127 1.471M7.5 16.667h5M10 3.333v13.334"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default NormalTextIcon
